exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n\r\n#kefu_icon_panel {\r\n    right: 10px;\r\n    bottom: 60px;\r\n    z-index: 100000;\r\n\r\n    /* panel style */\r\n    /*background-color: #FFF;*/\r\n    /*box-shadow: 1px 1px 4px #ddd;*/\r\n\r\n    box-sizing : border-box;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n\r\n    /*opacity: 0.9;*/\r\n\r\n    width: 70px;\r\n    word-break: break-all;\r\n    text-align: center;\r\n}\r\n\r\n#kefu_icon_panel a {\r\n    text-decoration: none;\r\n}\r\n\r\n#kefu_icon_panel img {\r\n    /*opacity: 0.7;*/\r\n    margin-bottom: 6px;\r\n    max-width: 46px;\r\n    height: auto;\r\n    display: block;\r\n}\r\n\r\n#kefu_icon_panel .text {\r\n    font-size: 80%;\r\n    width: 4em;\r\n    text-align: center;\r\n    margin: 0;\r\n    color: #333;\r\n}\r\n\r\n#kefu_icon_panel .closeButton {\r\n    position: absolute;\r\n    z-index: 1;\r\n    right: 0;\r\n    top: 0;\r\n\r\n    color: rgb(128,128,0);\r\n    font-size: 18px;\r\n}\r\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/shixun-mobile/css/kefu_icon_panel.css
 ** module id = 240
 ** module chunks = 7 24
 **/